import NotificationsContent from "page_components/shared/notifications/Content";

const Notifications = () => <NotificationsContent />;

export default Notifications;
